import React from 'react';
import { Paper, TableCell, TableHead, TableRow } from '@mui/material';

const headCells = [
  {
    id: 'partner',
    numeric: false,
    disablePadding: true,
    label: 'Partner'
  }
];

export function EnhancedTableHead(props) {
  const { order, orderBy } = props;

  return (
    <TableHead>
      <TableRow>
        {headCells.map(headCell => (
          <TableCell
            key={headCell.id}
            align={'left'}
            sortDirection={orderBy === headCell.id ? order : false}>
            {headCell.label}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}
